import { api } from '@/scripts/api';

export const PromoService = {
    /**
     * Get promos based on the query options.
     *
     * @param {{
     *      query?: ODataQueryOptions;
     *      signal?: AbortSignal;
     * }} options
     */
    async getPromos(options) {
        const queryParams = api.buildODataQuery(options.query ?? {});
        const endpoint = `/service/Promos${queryParams}`;
        return api.ajax({
            method: 'GET',
            url: endpoint,
            signal: options.signal,
        });
    },

    /**
     * Get a promo by ID.
     *
     * @param {number} id
     * @param {{
     *      query?: ODataQueryOptions;
     *      signal?: AbortSignal;
     * }} options
     */
    async getPromoById(id, options) {
        return this.getPromos({
            query: {
                ...(options?.query ?? {}),
                filter: {
                    ...(options?.query?.filter ?? {}),
                    Id: id,
                },
            },
            signal: options?.signal,
        });
    }
};